<div class="input-group" [class.input-focused]="isFocused()">
    <input
        type="text"
        class="form-control font-sm"
        [placeholder]="'Search...'"
        [value]="searchText()"
        (input)="onInput($event)"
        (focus)="isFocused.set(true)"
        (blur)="isFocused.set(false)"
        aria-label="Search"
        [id]="id()"
        [disabled]="disabled()"
    />
    <span class="input-group-text">
        <i class="fa-light fa-magnifying-glass"></i>
    </span>
</div>
